var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionLevel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#D2D2D9",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.817,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.952 15.217 65 61M15 61l24.048-45.783M61 71H19"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.6,
    cx: 10,
    cy: 70,
    r: 9.2
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.6,
    cx: 70,
    cy: 70,
    r: 9.2
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.333.86c5.842 2.466 10.614 4.482 14.315 6.047-.06 7.117-.19 12.766-2.675 17.641-1.984 3.893-5.483 7.27-11.605 10.539-6.256-3.604-10.014-7.01-12.133-11.134-2.304-4.485-2.67-9.797-2.324-17.038l2.298-.989.86-.369c5.922-2.539 9.676-4.105 11.264-4.698z",
    fill: "#EDEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m34.207 17.137 4.356 3.774 7.938-7.51"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionLevel);
export default __webpack_public_path__ + "static/media/permission-level.61fb1a6a8be94a200988a91211bfa482.svg";
export { ForwardRef as ReactComponent };